<template>
  <div class="banner-atom">
    <div class="banner-atom__image">
      <p v-if="title" class="banner-atom__text">{{ title }}</p>
      <div class="banner-atom__homePageContent">
        <p v-if="homePageTitle" class="banner-atom__homePageText" v-html="homePageTitle"></p>
        <p v-if="homePageSubTitle" class="banner-atom__homePageSubTitle">{{ homePageSubTitle }}</p>
      </div>
      <div class="banner-atom__photoCred">Foto: Aron Fjell / Unsplash</div>
      <img :src="image" alt="Banner" :style="{ height: imageHeight }" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    image: {
      type: String,
      required: true,
    },
    homePageTitle: String,
    homePageSubTitle: String,
  },
  computed: {
    imageHeight() {
      const path = this.$route.path;
      return path !== '/' ? '80vh' : '100vh';
    },
  },
};
</script>

<style scoped>
.banner-atom {
  bottom: 8px;
  left: 16px;
  font-size: 42px;
  font-family: 'fet', sans-serif;
}
.banner-atom__image {
  position: relative;
  overflow: visible;
}

.banner-atom__text {
  bottom: 8px;
  left: 27px;
  right: 16px;
  font-size: 42px;
  line-height: 1.1;
  letter-spacing: 1.5px;
  font-family: 'fet', sans-serif;
  position: absolute;
}
.banner-atom__homePageContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  text-align: center;
  padding: 20px;
}
.banner-atom__homePageText {
  font-size: 37px;
  font-family: 'fet', sans-serif;
  letter-spacing: 4px;
  margin-bottom: -9px;
}

.banner-atom__homePageSubTitle {
  display: flex;
  justify-content: center;
  line-height: 17px;
  font-size: 15px;
  letter-spacing: 1.2px;
  padding-top: 8px;
  font-family: 'bred', sans-serif;
  align-items: center;
  max-width: 400px;
}

.banner-atom img {
  width: 100%;
  object-fit: cover;
  height: 80vh;
}
.banner-atom__photoCred {
  font-family: 'bred', sans-serif;
  font-size: 7px;
  position: absolute;
  bottom: 8px;
  right: 16px;
  letter-spacing: 1.2px;
  filter: opacity(0.5);
}

@media all and (min-width: 1304px) {
  .banner-atom__text {
    left: 45px;
  }
  .banner-atom__homePageContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 50%;

    transform: translateY(-50%);
    left: 0;
    right: 0;
    text-align: center;
  }
  .banner-atom__homePageText {
    font-size: 100px;
    letter-spacing: 5px;
    margin-bottom: -20px;
  }

  .banner-atom__homePageSubTitle {
    font-size: 22px;
    letter-spacing: 1.2px;
    font-family: 'bred', sans-serif;
    align-items: center;
    max-width: none;
  }
}
@media all and (max-width: 600px) {
  .banner-atom__homePageText {
    line-height: 2rem;
    margin-bottom: 0.5rem;
  }

  /*   .banner-atom__photoCred {
    bottom: -1rem;
  } */
}
</style>
